var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__folder--system icon--style--outline icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M9.394 5l2.5 1.663.5.336H21V19H3V5h6.394M10 3H3a2 2 0 00-2 2v14a2 2 0 002 2h18a2 2 0 002-2V7a2 2 0 00-2-2h-8z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }